import { css, type Theme } from "@emotion/react";

export const dropdownContent = css`
  margin-top: 0.5rem;
`;

export const rsoButton = (theme: Theme) => css`
  display: flex;
  min-width: 14.75rem;
  align-items: center;
  justify-content: start;
  padding: 0.5rem;
  gap: 0.125rem;
  border-radius: 0.5rem;
  border: 1px ${theme.system.borderBase} solid;

  :hover {
    background-color: ${theme.system.backgroundMuted};
  }
`;
